var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.50002C21.75 8.91002 21.41 9.25002 21 9.25002H3C2.59 9.25002 2.25 8.91002 2.25 8.50002C2.25 8.09002 2.59 7.75002 3 7.75002H4.02L4.4 5.94002C4.76 4.19002 5.51 2.58002 8.49 2.58002H15.51C18.49 2.58002 19.24 4.19002 19.6 5.94002L19.98 7.75002H21C21.41 7.75002 21.75 8.09002 21.75 8.50002Z",
    fill: "#B2DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 14.16C22.03 12.51 21.59 10.75 18.38 10.75H5.62C2.41 10.75 1.98 12.51 1.82 14.16L1.26 20.25C1.19 21.01 1.44 21.77 1.96 22.34C2.49 22.92 3.24 23.25 4.04 23.25H5.92C7.54 23.25 7.85 22.32 8.05 21.71L8.25 21.11C8.48 20.42 8.54 20.25 9.44 20.25H14.56C15.46 20.25 15.49 20.35 15.75 21.11L15.95 21.71C16.15 22.32 16.46 23.25 18.08 23.25H19.96C20.75 23.25 21.51 22.92 22.04 22.34C22.56 21.77 22.81 21.01 22.74 20.25L22.18 14.16ZM9 16.25H6C5.59 16.25 5.25 15.91 5.25 15.5C5.25 15.09 5.59 14.75 6 14.75H9C9.41 14.75 9.75 15.09 9.75 15.5C9.75 15.91 9.41 16.25 9 16.25ZM18 16.25H15C14.59 16.25 14.25 15.91 14.25 15.5C14.25 15.09 14.59 14.75 15 14.75H18C18.41 14.75 18.75 15.09 18.75 15.5C18.75 15.91 18.41 16.25 18 16.25Z",
    fill: "#B2DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default __webpack_public_path__ + "static/media/Traffic.082c807e3e3ffedb6e6a305f4d69fbc5.svg";
export { ForwardRef as ReactComponent };